import { useGetWorkspacesQuery } from '@carboncopyco/data';
import { useMemo } from 'react';
import { useUser } from '../store/context/UserContext';

export const useWorkspacesMap = () => {
  const { activeOrganization } = useUser();
  const organizationId = activeOrganization?.id.toString() || '';
  const { data: workspaces = [] } = useGetWorkspacesQuery({
    organizationId,
  });

  return useMemo(
    () =>
      Object.fromEntries(
        workspaces?.map((workspace) => [workspace.id, workspace])
      ),
    [workspaces]
  );
};
